const MIB = 1024 * 1024;
const HEX_BASE = 16;
const HEX_WIDTH = 2;

const readBlob = (blob) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsArrayBuffer(blob);
});

const hexOf = (buffer) => Array.from(new Uint8Array(buffer)).map(byte => byte.toString(HEX_BASE).padStart(HEX_WIDTH, '0')).join('');

const digestOf = async (blob) => hexOf(await crypto.subtle.digest('SHA-256', await readBlob(blob)));

export const fingerprintOf = async (file) => {
    const head = await digestOf(file.slice(0, Math.min(MIB, file.size)));
    const tail = await digestOf(file.slice(Math.max(0, file.size - MIB), file.size));
    return `v1:${file.size}:${head}:${tail}`;
};
